import {AthleteSeason} from "./athleteSeason";

export class Season {

    id?: string;
    name: string = '';
    startDate?: string;
    endDate?: string;
    status?: string;
    createdAt?: string;
    updatedAt?: string;
    createdById?: string;
    companyId: string = '';
    isCurrent: number = 0;
    AthleteSeason: AthleteSeason = new AthleteSeason();


    constructor(raw?: Season) {
        if (raw){
            this.id = raw.id;
            this.name = raw.name;
            this.startDate = raw.startDate;
            this.endDate = raw.endDate;
            this.status = raw.status;
            this.createdAt = raw.createdAt;
            this.updatedAt = raw.updatedAt;
            this.createdById = raw.createdById;
            this.companyId = raw.companyId;
            if (raw.AthleteSeason) this.AthleteSeason = raw.AthleteSeason;
            this.isCurrent = raw.isCurrent;
        }
    }

    static fromApiList(raws?: Season[]): Season[] {
        let list: Season[] = []

        if (!raws) return list
        raws.forEach(raw => {
            list.push(new Season(raw))
        })

        return list
    }
}
